Ext.define('SA.view.ImportColumnsStep', {
    alias: 'widget.import-columns-step',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-import-columns-step',
    hidden: true,

    items: [
        {
            xtype: 'component',
            cls: 'sa-import-columns-step-instructions',
            itemId: 'instructions',

            html: [
                'Please indicate which column contains the Location ID of your locations. The Location ID is ',
                'the unique ID for each location, and we need this to match your locations to the locations ',
                'in our database. You can also assign each column a “friendly name” to make them more user ',
                'friendly. Last, let us know if there are any columns you do not want to import.'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-import-columns-step-grid',
            itemId: 'grid',

            html: [
                '<table>',
                    '<thead>',
                        '<th>Import?</th>',
                        '<th>Column Name</th>',
                        '<th>Data Type</th>',
                        '<th>Data Format</th>',
                        '<th>Alternate “Friendly” Name <span class="sa-import-columns-step-grid-value-optional-label">(optional)</span></th>',
                    '</thead>',
                    '<tbody></tbody>',
                '</table>'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-import-columns-step-grid-clone-target',
            itemId: 'gridCloneTarget'
        }
    ],

    initComponent() {
        this.callParent();

        this.instructions = this.down('#instructions');
        this.grid = this.down('#grid');
        this.gridCloneTarget = this.down('#gridCloneTarget');
    },

    getValue() {
        var columns = this.rows.filter(row => row.isRowSelected()).map(row => row.getValue());

        return columns.map(column => new SA.model.createimport.ColumnDefinition(column));
    },

    refresh(headerNames) {
        var tbody = this.el.dom.querySelector('tbody'),
            rows = this.rows = headerNames.map(headerName => new SA.view.ImportColumnRow(headerName)),
            rowEls = rows.map(row => row.getEl());

        tbody.innerHTML = '';

        rowEls.forEach(el => tbody.appendChild(el));
    },

    resizeWithConstraint({maxWidth, maxHeight}) {
        var me = this,
            gridMarginWidth = getPaddingWidth() + 32, 
            gridWidth = Math.min(getFullGridWidth(), maxWidth - gridMarginWidth),
            stepWidth = gridWidth + gridMarginWidth;

        this.grid.setWidth(gridWidth);

        this.el.setStyle({
            maxHeight: maxHeight + 'px',
            width: stepWidth + 'px'
        });

        function getPaddingWidth() {
            var {paddingLeft, paddingRight} = window.getComputedStyle(me.el.dom);

            return parseFloat(paddingLeft) + parseFloat(paddingRight);
        }

        function getFullGridWidth() {
            var target = me.gridCloneTarget.el.dom,
                clone = me.grid.el.dom.cloneNode(true);

            clone.setAttribute('id', null);
            clone.style.width = null;

            target.innerHTML = '';
            target.appendChild(clone);

            return Ext.fly(clone).getWidth();
        }
    }
});
